var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start mb-5" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "3", lg: "2", xl: "1" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-xl-center" },
                  [_c("b-button-group", { staticClass: "mt-3 mt-sm-0" })],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _c(
                  "b-tab",
                  {
                    attrs: { title: _vm.$t("common.security.configurations") },
                  },
                  [
                    _c("security-list", {
                      key: _vm.refreshKey,
                      attrs: {
                        typeList: "configuration",
                        spinnerActivated: _vm.activateSpinner,
                      },
                      model: {
                        value: _vm.tabValue,
                        callback: function ($$v) {
                          _vm.tabValue = $$v
                        },
                        expression: "tabValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.canSeeCA
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.ca") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "ca",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canSeeCertificates
                  ? _c(
                      "b-tab",
                      {
                        attrs: {
                          title: _vm.$t("common.security.certificates"),
                        },
                      },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "certificate",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canSeePrivateKeys
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.priv_ks") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "privatekey",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }